<template>
  <div class="vendor-menu m-t-0 m-b-30" :class="{ 'vendor__pickup-enabled': activeVendor.pickupTimeSelectionEnabled }">
    <vendor-menu-category
      v-for="(category, index) in menu"
      :key="index"
      :category-name="category.displayName"
      :category-items="category.items"
      :sub-categories="category.posSubCategories"
    >
    </vendor-menu-category>
  </div>
</template>

<script>
import VendorMenuCategory from "./menu-category/VendorMenuCategory";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "VendorMenuList",
  components: { VendorMenuCategory },
  computed: {
    ...mapGetters("vendor", {
      activeVendor: "getActiveVendor",
      menu: "getVendorMenu"
    })
  },
  methods: {
    ...mapActions({
      setActiveDayPart: "vendor/setActiveDayPart"
    })
  },
  mounted() {
    this.setActiveDayPart();
  }
};
</script>

<style scoped lang="scss">
@include menu-wide {
  .vendor-menu {
    order: 4;
    width: 100%;
    min-height: calc(100vh - 304px);

    &.vendor__pickup-enabled {
      min-height: calc(100vh - 349px);
      @include respond-to-mobile {
        min-height: 100%;
      }
    }

    @include respond-to-mobile {
      min-width: 100%;
      min-height: 100%;
    }
  }
}

@include menu-closed {
  .vendor-menu {
    padding-top: 50px;

    @include respond-to-mobile {
      padding-top: 0;
    }
  }
}

.vendor-menu {
  padding-top: ($spacer * 1.5);
  transition: padding-top 0.3s linear;
  @include respond-to-mobile {
    padding-top: $spacer;
  }
}
</style>
